export const getTradeBots = ({ tradeBots }) => {
  const keys = Object.keys(tradeBots.tradesBotById);
  if (!keys.length) return null;
  return tradeBots.tradesBotById[keys[0]];
};
